var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomInfo = function SvgCustomInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 11.75c0 5.385-4.365 9.75-9.75 9.75S2 17.135 2 11.75 6.365 2 11.75 2s9.75 4.365 9.75 9.75Zm-8.938-4.604a.813.813 0 1 1-1.625 0 .813.813 0 0 1 1.626 0Zm-.812 2.437a.813.813 0 0 0-.813.813v5.958a.813.813 0 0 0 1.626 0v-5.958a.813.813 0 0 0-.813-.813Z",
    fill: "currentColor"
  })));
};

export default SvgCustomInfo;